import { useWhitelabelContext } from "@app/context/whitelabel-context";
import { useLiteAppContext } from "@app/helpers/hooks";

export const useIsAccountAvailable = (): boolean => {
  const { features } = useLiteAppContext();
  const { legacy_partner_settings } = useWhitelabelContext();

  const should_hide_account_links =
    legacy_partner_settings?.features_override?.SHOULD_HIDE_ACCOUNT_LINKS ??
    !!features.SHOULD_HIDE_ACCOUNT_LINKS;

  return !should_hide_account_links;
};
